import React, { useState } from "react";
import { Layout } from "@/components/Layout";
import { PageHero } from "@/components/PageHero";
import { api } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

export default function SubmitTool() {
  const [form, setForm] = useState({ name: "", url: "", category: "Chat & LLMs", description: "", submitter_email: "" });
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    await api.post("/submit-tool", form);
    setDone(true);
  };
  if (done) {
    return <Layout hideRightPanel>
      <div className="text-center py-20" data-testid="submit-success">
        <CheckCircle2 size={48} className="mx-auto text-[#F97316] mb-4"/>
        <h1 className="font-display text-2xl font-bold text-[#0B1220] tracking-tight">Thanks for the tip.</h1>
        <p className="text-[#5B6478] mt-2">We'll review {form.name} and publish it if it meets the bar.</p>
      </div>
    </Layout>;
  }
  return (
    <Layout hideRightPanel>
      <PageHero
        testId="submit-hero"
        eyebrow="Community"
        badge="7-Day Review"
        title={<>Submit a <span className="italic">tool.</span></>}
        sub="Know a great AI tool we missed? Tell us. We review every submission within 7 days."
      />
      <form onSubmit={submit} className="curio-card p-6 space-y-4" data-testid="submit-form">
        {[["name","Tool name"],["url","Website URL"],["description","One-line pitch"],["submitter_email","Your email (optional)"]].map(([k,l])=>(
          <div key={k}>
            <label className="text-xs uppercase tracking-widest text-[#5B6478] font-bold block mb-1">{l}</label>
            <input value={form[k]} onChange={e=>setForm({...form, [k]: e.target.value})} required={k!=="submitter_email"} className="w-full bg-[#F7F9FC] border border-[#E3E8F0] rounded-xl px-4 py-2.5 text-sm focus:outline-none focus:border-[#0B1220]" data-testid={`submit-${k}`}/>
          </div>
        ))}
        <div>
          <label className="text-xs uppercase tracking-widest text-[#5B6478] font-bold block mb-1">Category</label>
          <select value={form.category} onChange={e=>setForm({...form, category: e.target.value})} className="w-full bg-[#F7F9FC] border border-[#E3E8F0] rounded-xl px-4 py-2.5 text-sm">
            {["Chat & LLMs","Image","Video","Music & Audio","Voice","Writing","No-Code & Vibe Coding","Automation & Workflows","Research","Productivity","Health","Finance","Education","Web3 & Crypto","Creative/Film","AI Agents"].map(c=><option key={c}>{c}</option>)}
          </select>
        </div>
        <button className="btn-coral w-full justify-center">Submit for review</button>
      </form>
    </Layout>
  );
}
